<template>
  <span
    class="title-question-icon"
    @click.prevent.stop="toggleHelp()"
    v-if="hasContent"
  >
    <iquestion />
  </span>
</template>

<script>
import iquestion from '../icons/question'

export default {
  props: {
    title: {
      type: String,
    },
    subtitle: {
      type: String,
      default: '1',
    },
    content: {
      type: String,
    },
  },
  methods: {
    toggleHelp() {
      this.$store.commit('layout/updateModal', {
        modal: 'help',
        show: true,
        title: this.title,
        content: this.content,
        subtitle:
          this.subtitle !== '1'
            ? this.subtitle
            : this.$t('modals.messages.reference'),
      })
    },
  },
  computed: {
    hasContent() {
      return !!this.title && !!this.content && !!this.subtitle
    },
  },
  components: {
    iquestion,
  },
}
</script>

<style lang="scss">
@media (min-width: 768px) {
  * > .title-question-icon {
    opacity: 0;
    transition: 0.2s;
  }
}

*:hover > .title-question-icon {
  opacity: 1;
}
</style>
